import { t } from "i18next"
import React, { useMemo, useState } from "react"
import { Sort } from "components/custom"
import { Button, Icon, SelectInput } from "components/common"
import { Col, Form, Row } from "antd"
import cx from "clsx"
import { leadTypes } from "constants/list"

const items = () => [
  { id: "1", columnName: "id", sortOrder: "asc", label: t("Lead ID Ascending") },
  { id: "2", columnName: "id", sortOrder: "desc", label: t("Lead ID Descending") },
  { id: "3", columnName: "latestActivity", sortOrder: "desc", label: t("Last Task Date Latest") },
  { id: "4", columnName: "latestActivity", sortOrder: "asc", label: t("Last Task Date Oldest") },
  { id: "5", columnName: "nextStatusDeadline", sortOrder: "desc", label: t("Next Task Date Latest") },
  { id: "6", columnName: "nextStatusDeadline", sortOrder: "asc", label: t("Next Task Date Oldest") },
]

function LeadsFilters({ filterObject,filterClass,onSearch, onSort }) {
  const [filters, setFilters] = useState(filterObject && { ...filterObject })

  const currentSort = items()?.filter(
    item => item?.columnName === filterObject?.sortBy && item?.sortOrder === filterObject?.sortOrder
  )[0]

    const isFilterApplied = useMemo(() => {
    return Object.keys(filterObject).filter(
      e => !["sortBy", "sortOrder", "pageLimit"].find(item => item == e) && !!filterObject[e]
    ).length
  }, [filterObject])

  const checkIfFiltersExist = useMemo(() => {
    if (filters?.interestedIn) {
      return isFilterApplied > 0
    }
      return false
  }, [filterObject,filters])

  const handleClear = (filterKey, enableSearch = false) => {
    let obj = { ...filters }
    if (Array.isArray(filterKey)) {
        filterKey.forEach(key => {
          delete obj[key]
        })
      obj = {
        ...obj,
        sortBy: "id",
        sortOrder: "desc",
        pageLimit: 10,
      }
      enableSearch ? onSearch(obj) : setFilters(obj)
      return
    }
    delete obj[filterKey]
    obj = {
      ...obj,
      sortBy: "id",
      sortOrder: "desc",
      pageLimit: 10,
    }
    enableSearch ? onSearch(obj) : setFilters(obj)
  }

  return (
    <>
     <Row className={cx("mbe-12", filterClass)} align="middle" gutter={[8, 16]}>
        <Col flex="0.5">
          <Form.Item className="mbe-0">
            <SelectInput
              key={"interestedIn"}
              value={filterObject?.interestedIn}
              placeholder={t("Select lead type")}
              showArrow
              options={leadTypes()}
              onChange={(value, options) => {
                setFilters({ ...filters, interestedIn: value })
              }}
              allowClear
              onClear={() => handleClear("interestedIn")}
            />
          </Form.Item>
        </Col>

        <Col flex="60px">
          <Button
            type="primary"
            icon={<Icon icon="FiSearch" />}
            text=""
            onClick={() => onSearch(filters)}
            style={{ height: 48 }}
            block
          />
        </Col>

        {checkIfFiltersExist && (
          <Col flex="60px">
            <Button
              type="link"
              danger
              text={t("Reset")}
              onClick={() => {
                handleClear(Object.keys(filters), true)
              }}
            />
          </Col>
        )}
      </Row>
      <Row className="mbe-12 pi-24" justify="end" style={{ gap: 8 }}>
      <Sort
        options={items()}
        sort={currentSort}
        onClickItem={item =>
          (filterObject?.sortBy !== item?.columnName || filterObject?.sortDirection !== item?.sortOrder) && onSort(item)
        }
      />
    </Row>
    </>
    
  )
}

export default LeadsFilters
